module.exports = __webpack_public_path__ + "officialStatic/img/cou2.65780ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/cou2.jpg
// module id = i3qK
// module chunks = 0